import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, FIELD } from "@/lib/api";
import { Field } from "@/components/common/Field";
import { Input } from "@/components/ui/input";

const EMPTY = { current_password: "", new_password: "", confirm: "" };

export const ChangePassword = ({ email }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("New passwords don't match.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      setF(EMPTY);
      toast.success("Password changed. Other devices have been signed out.");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="border border-white/10 p-6 md:p-8 max-w-lg space-y-5" data-testid="change-password-form">
      <p className="text-sm text-white/60">Signed in as <span className="text-white">{email}</span>. Use this password with the email sign-in on the admin page.</p>
      <Field label="Current Password"><Input className={FIELD} type="password" autoComplete="current-password" value={f.current_password} onChange={set("current_password")} data-testid="current-password-input" /></Field>
      <Field label="New Password (10+ characters)" required><Input className={FIELD} type="password" autoComplete="new-password" minLength={10} required value={f.new_password} onChange={set("new_password")} data-testid="new-password-input" /></Field>
      <Field label="Confirm New Password" required><Input className={FIELD} type="password" autoComplete="new-password" minLength={10} required value={f.confirm} onChange={set("confirm")} data-testid="confirm-password-input" /></Field>
      <button className="btn-gold !py-3" disabled={busy} data-testid="change-password-submit-button">{busy ? "Saving…" : "Change Password"}</button>
    </form>
  );
};
